module.exports = ".kuva {\r\n    width: 100%;\r\n    height: 275px;\r\n    background-image: url('/assets/img/maisema.png');\r\n    padding-top: 10px; \r\n    background-size: cover;\r\n}\r\n\r\n@media (min-width: 1400px) {\r\n    .container {\r\n        max-width: 1290px;\r\n    }\r\n}\r\n\r\n@media (min-width: 1600px) {\r\n    .container {\r\n        max-width: 1500px;\r\n    }\r\n}\r\n\r\n@media (min-width: 1800px) {\r\n    .container {\r\n        max-width: 1600px;\r\n    }\r\n}\r\n  "


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main